module.exports = __webpack_public_path__ + "static/media/power655.e851824a.png";